import React,{useMemo} from 'react'
import PropTypes from 'prop-types'
import {
	Row,
	Col,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  ModalFooter,
  Modal,
  FormText,
  CustomInput,
} from 'reactstrap'
import CardType from 'lib/Core/Backend/Controllers/CardType'
import Spinner from 'react-bootstrap/Spinner';

const EditCardTypeModal = ({
  isOpen,
  toggle,
  onOpened,
  activeOp,
  activeOpText,
  onImageChange,
  cardImageRef,
  handleCancelClick,
  handleSaveClick,
  addNewcardLoading,
  formRef,
  maxAmtControl,
  token,
  setCurrencyId,
  currencyId,
  cardImageInput,
  setCardImageInput,
  setCurrencyName,
  currencyName,

}) => {
  const cardTypeCtl = useMemo(() => new CardType(token),[token]);
 
  const onTypeChange = () => {
		if (formRef.current.type.checked) {
			document.getElementById("baseAmountTag").innerHTML = "Face Value";
			maxAmtControl.current.style.display = "none";
		} else {
			document.getElementById("baseAmountTag").innerHTML = `Min. Amount<span style="color: red;">*</span>`;
			maxAmtControl.current.style.display = "block";
		}
	}

  const handleBrandCardType = (e) =>{
   const brandValue = e.target.value;
   if(brandValue && brandValue > 0){
    cardTypeCtl.brandCatalog(brandValue,(data)=>{
      
      if(data && !data.error){
      setCurrencyId(data?.currency)
      setCurrencyName(data?.currencyName)
      setCardImageInput(data?.logoUuid)
      }
    });
   }

  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" onOpened={onOpened}>
      <ModalHeader className="custom_header_colourTwo" toggle={handleCancelClick}>{activeOp} Card Type</ModalHeader>
      <ModalBody>
        <p className="card-just-text">
          {activeOpText}
        </p>
        <Form innerRef={formRef} encType="multipart/form-data">
          <Input type="hidden" name="cardTypeId"/>
          <FormGroup>
            <Label for="brand">Brand<span style={{color:"red"}}>*</span></Label>
            <Input type="select" name="brand" id="brand" onChange={(e)=>handleBrandCardType(e)}/>
          </FormGroup>
          <FormGroup>
            <Label for="name">Product Name<span style={{color:"red"}}>*</span></Label>
            <Input id="name" name="name" type="text" placeholder="Product name for the gift card type" maxLength="70"/>
          </FormGroup>
          <FormGroup className='d-none'>
            <Label for="currency">Currency</Label>
            <Input id="currency" name="currency" type="select"/>
          </FormGroup>
          <FormGroup>
            <CustomInput id="cardTypeSwitch" type="switch" name="type" label="Fixed Value Card" onChange={onTypeChange}/>
          </FormGroup>
          <FormGroup>
            <Label id="baseAmountTag" for="amount">Face Value<span style={{color:"red"}}>*</span></Label>
            <Input id="amount" name="amount" type="number" placeholder="Amount of the gift card type"/>
          </FormGroup>
          <div ref={maxAmtControl}>
            <FormGroup>
              <Label for="maxAmount">Max. Amount<span style={{color:"red"}}>*</span></Label>
              <Input id="maxAmount" name="maxAmount" type="number" placeholder="Maximum amount of the gift card type" checked="checked"/>
            </FormGroup>
          </div>
          <Row >
            <Col md={2} className="justify-content-center d-none">
              <div ref={cardImageRef} className="ncentiva-gift-card-block" style={{marginTop: "25px"}}/>
            </Col>
            <Col md={10} style={{padding: "0 30px 0 30px"}}>
              <FormGroup className='d-none'>
                <Label for="imageFile">Image file for the gift card</Label>
                <Input type="text" name="imageFile" id="imageFile"/>
            
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancelClick}>Cancel</Button>{' '}
        <Button className='btn btn-primaryTwo' onClick={handleSaveClick} disabled={addNewcardLoading}>{!addNewcardLoading && "Save"}{
        addNewcardLoading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
      </ModalFooter>
    </Modal>
  )
}

EditCardTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onOpened: PropTypes.func.isRequired,
  activeOp: PropTypes.string.isRequired,
  activeOpText: PropTypes.string.isRequired,
  onImageChange: PropTypes.func.isRequired,
  handleCancelClick: PropTypes.func.isRequired,
  handleSaveClick: PropTypes.func.isRequired,
  formRef: PropTypes.any.isRequired,
  cardImageRef: PropTypes.any.isRequired
}

export default EditCardTypeModal
